/**
 * Default edge/connection payload — kept separate from src/config.ts so Node (e2e) can import
 * without loading Vite-only `import.meta` / package.json.
 */
import {
  ELinkMdi,
  EEdgeType,
  ELinkSpeed,
  ELinkDuplex,
  EUntaggedVlan,
  IEdgeExtraData,
  EAllowIncomingPackets,
} from './modules/network-configuration/edges/types';

export const defaultConnectionData: IEdgeExtraData = {
  edgeType: EEdgeType.BEZIER,
  vlanIds: [],
  untaggedVlan: EUntaggedVlan.AUTO,
  allowIncomingPackets: EAllowIncomingPackets.AUTO,
  useCustomDescription: false,
  customDescription: '',
  enableLink: true,
  autoNegotiation: true,
  linkSpeed: ELinkSpeed.AUTO,
  linkDuplex: ELinkDuplex.AUTO,
  linkMdi: ELinkMdi.AUTO,
  enableMonitoring: false,
  cableType: undefined,
};
